module.exports = __webpack_public_path__ + "static/media/sign-in-logo-pink-october.a872c646.svg";